// eslint-disable-next-line jira/filename-case
import React, { type MouseEvent } from 'react';
import { ViewTemplatesButton } from '@jira/polaris__component-view-template-library/src/ViewTemplatesButton.tsx';
import type { ViewKind } from '@jira/polaris__domain-view/src/ViewKind.types.tsx';
import { useCanCreateFields } from '@jira/polaris__component-permissions-store/src/useCanCreateFields.tsx';
import MenuGroup from '@atlaskit/menu/menu-group';
import Section from '@atlaskit/menu/section';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Flex } from '@atlaskit/primitives/compiled/flex';
import { cssMap } from '@atlaskit/css';

import { type NavigationContainer, isNavigationProject } from '../../../common/types.tsx';
import { ViewMenuItems } from './ViewMenuItems.tsx';

const stopEventPropagation = (event: MouseEvent<HTMLDivElement>) => event.stopPropagation();

const MIN_WIDTH_IN_PX = 250;

const styles = cssMap({
	menu: {
		minWidth: `${MIN_WIDTH_IN_PX}px`,
	},
});

export const MENU_TEST_ID =
	'navigation-apps-sidebar-nav4-sidebars-common-jpd-nav-views.ui.create-view-menu.menu.create-view-menu';

export type MenuProps = {
	container?: string;
	sectionId?: string;
	navigationContainer: NavigationContainer;
	onMenuItemClick: (arg: { type: ViewKind; container?: string }) => void;
	onPopupClose: () => void;
};

export const Menu = ({
	container,
	sectionId,
	navigationContainer,
	onMenuItemClick,
	onPopupClose,
}: MenuProps): React.JSX.Element => {
	const canCreateFields = useCanCreateFields();
	const isViewTemplateLibraryEnabled = canCreateFields && isNavigationProject(navigationContainer);

	return (
		<Box onMouseEnter={stopEventPropagation} onMouseLeave={stopEventPropagation}>
			<MenuGroup minWidth={MIN_WIDTH_IN_PX} testId={MENU_TEST_ID}>
				<Flex>
					<Box xcss={styles.menu}>
						<ViewMenuItems
							container={container}
							navigationContainer={navigationContainer}
							onClick={onMenuItemClick}
						/>
						{isViewTemplateLibraryEnabled && (
							<Section hasSeparator>
								<ViewTemplatesButton
									onClick={onPopupClose}
									projectId={navigationContainer.projectId}
									projectKey={navigationContainer.projectKey}
									containerId={sectionId}
								/>
							</Section>
						)}
					</Box>
				</Flex>
			</MenuGroup>
		</Box>
	);
};
